import { useQuery } from 'react-query';
import configs from 'config';

import { USE_INFO_USER } from 'constants/Auth';
import { getInforUser } from '../api/auth';

export function useInforAuth() {
  const systemRecruit = 2;
  const {
    data: response,
    isLoading,
    error,
  } = useQuery(USE_INFO_USER, async () => {
    const response = await getInforUser({ system_id: systemRecruit });

    return response;
  });
  const data = response?.data;

  return {
    ...data,
    isLoading,
    error,
    permission: data?.data?.hr_permission,
    positionId: data?.data?.position_id,
    status: response?.status,
  };
}

// Chỉ hiện mục ACMS BOM khi BOM trả lời có quyền; lỗi hoặc chưa trả lời thì ẩn (bom-task, đặc tả 006).
export function useBomAccess() {
  const { data } = useQuery(
    'USE_BOM_ACCESS',
    async () => {
      const response = await fetch(`${configs.DOMAIN_AMS_BOM}/api/access/me`, { credentials: 'include' });
      return response.json();
    },
    { retry: false, refetchOnWindowFocus: false, staleTime: 5 * 60 * 1000 },
  );

  return data?.allowed === true;
}
